import category from '@/api/categories'

export default ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    category.getCategoryList(result => {
      commit('categoryList', result.data.data)
      resolve(result.data.data)
    }, param)
  })
}
